export default "__VITE_ASSET__Dtf_QGgY__"